import ErpRepository from '../repository/erpRepository'

// Sends event and data for analytics
export const sendAnalytics = (event, extra_data={}) => {
  ErpRepository({
    datasourceUrl: 'settings/company/set_track_event/',
    method: 'POST',
    data: {
      event: event,
      extra_data: extra_data,
    },
  }).catch(() => {})
}
